var s = /* @__PURE__ */ ((i) => (i.one_shot = "one_shot", i.subscription = "subscription", i.limited_subscription = "limited_subscription", i))(s || {});
export {
  s as PricePlanTypeEnum
};
